import type { AdminNotificationPayload } from '../gateway/contracts';

export class AdminPopupAcknowledgements {
  private readonly acknowledged = new Set<string>();

  has(playerId: number, message: AdminNotificationPayload): boolean {
    return this.acknowledged.has(this.key(playerId, message));
  }

  acknowledge(playerId: number, message: AdminNotificationPayload): void {
    this.acknowledged.add(this.key(playerId, message));
  }

  private key(playerId: number, message: AdminNotificationPayload): string {
    return [playerId, message.villageId ?? 0, message.id, message.createdAt].join(':');
  }
}
